import Vue from 'vue';
import VueRouter from 'vue-router';
import { JudLogin } from '../axiosconfig/login.js';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);
import Home from '../views/home/Home.vue';
import login from '../views/login/login.vue';
import Report from '../views/report/Report.vue';
import AnnouncementDetail from '../views/announcement/detail/AnnouncementDetail.vue';
import Program from '../views/program/Program.vue';
import ProgramDetail from '../views/program/detail/ProgramDetail.vue';
import UsercenterInfo from '../views/usercenter/info/usercenterInfo.vue';
import UsercenterIdInfo from '../views/usercenter/idinfo/usercenterIdInfo.vue';
import UsercenterReport from '../views/usercenter/report/UsercenterReport.vue';
import teamMenu from '../views/usercenter/teamMenu/teamMenuInfo.vue';
import UsercenterReportDetail from '../views/usercenter/report/UsercenterReportDetail.vue';
import UsercenterSiteMsg from '../views/usercenter/sitemsg/UsercenterSiteMsg.vue';
import updateSafetyDetail from '../views/updataSafetyInfo/updateSafetyDetail.vue';
import aboutUs from '../views/aboutUs/aboutUs.vue';

const router = new VueRouter({
    linkActiveClass: 'is-active',
    linkExactActiveClass: 'is-active',
    routes: [
        {
            path: '/',
            redirect: '/home',
            name: 'home',
            component: Home,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/ranking',
            name: 'HeroRank',
            component: resolve => require(['../views/heroRank/HeroRank.vue'], resolve),
            meta: {
                title: '英雄榜'
            }
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/report',
            name: 'report',
            component: Report,
            meta: {
                title: '提交漏洞'
            }
        },
        {
            path: '/program/detail',
            name: 'programDetail',
            component: ProgramDetail,
            meta: {
                title: '奖励计划详情'
            }
        },
        {
            path: '/announcement',
            redirect: 'announcement/list',
            meta: {
                title: '公告'
            },
            component: resolve => require(['../views/announcement/Announcement.vue'], resolve),
            children: [
                {
                    path: '/announcement/list',
                    name: 'list',
                    meta: {
                        title: '公告'
                    },
                    component: resolve => require(['../views/announcement/Announcement.vue'], resolve)
                }
            ]
        },
        // {
        //     path: '/securityUpdates',
        //     name: 'updataSafetyInfo',
        //     meta: {
        //         title: '安全更新'
        //     },
        //     component: resolve => require(['@/views/updataSafetyInfo/updataSafetyInfo.vue'], resolve)
        // },
        // {
        //     path: '/securityUpdatesDetail',
        //     name: 'updateSafetyDetail',
        //     meta: {
        //         title: '安全更新详情'
        //     },
        //     component: updateSafetyDetail
        // },
        {
            path: '/aboutUs',
            name: 'aboutUs',
            meta: {
                title: '关于我们'
            },
            component: aboutUs
        },
        {
            path: '/announcement/detail',
            name: 'announcementDetail',
            component: AnnouncementDetail,
            meta: {
                title: '公告详情'
            }
        },

        {
            path: '/usercenter',
            redirect: '/usercenter/info',
            name: 'usercenter',
            component: UsercenterInfo,
            meta: {
                title: '个人资料'
            },
            children: [
                {
                    path: '/usercenter/info',
                    name: 'usercenterInfo',
                    meta: {
                        title: '个人资料',
                        userCenterMenuIndex: '1'
                    },
                    component: UsercenterInfo
                }
            ]
        },
        {
            path: '/usercenter/idinfo',
            name: 'usercenterIdInfo',
            component: UsercenterIdInfo,
            meta: {
                title: '身份认证',
                userCenterMenuIndex: '2'
            }
        },
        {
            path: '/usercenter/teamMenu',
            name: 'teamMenu',
            component: teamMenu,
            meta: {
                title: '团队菜单',
                userCenterMenuIndex: '5'
            }
        },
        {
            path: '/usercenter/report',
            redirect: '/usercenter/report/list',
            name: 'usercenterReport',
            component: UsercenterReport,
            meta: {
                title: '我的漏洞'
            },
            children: [
                {
                    path: '/usercenter/report/list',
                    name: 'usercenterReport',
                    meta: {
                        title: '我的漏洞',
                        userCenterMenuIndex: '3'
                    },
                    component: UsercenterReport
                }
            ]
        },
        {
            path: '/usercenter/report/detail',
            name: 'usercenterReportDetail',
            component: UsercenterReportDetail,
            meta: {
                title: '漏洞详情',
                userCenterMenuIndex: '3'
            }
        },
        {
            path: '/usercenter/sitemsg',
            name: 'usercenterSiteMsg',
            component: UsercenterSiteMsg,
            meta: {
                title: '消息中心',
                userCenterMenuIndex: '4'
            }
        },
        {
            path: '/login',
            name: 'login',
            component: login,
            meta: {
                title: '登录'
            }
        },
        {
            path: '*',
            name: '404',
            redirect: '/',
            component: Home,
            meta: {
                title: '404'
            }
        }
    ]
});
router.beforeEach((to, from, next) => {
    JudLogin()
        .then(val => {
            if (val === 'noLogin') {
                // eslint-disable-next-line no-undef
                JSAnalysisSDK.track({
                    actionCode: `Entry-${to.name}`,
                    content: { urlCategoryName: to.meta.title }
                });
            } else {
                // eslint-disable-next-line no-undef
                JSAnalysisSDK.track({
                    uid: val,
                    actionCode: `Entry-${to.name}`,
                    content: { urlCategoryName: to.meta.title }
                });
            }
            next();
        })
        .catch(error => {
            console.log(error);
            next();
        });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js